<template>
  <!-------------------- END - Controles arriba de tabla-------------------->
  <div class="invoice-table">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Abono</th>
          <th style="width: 200px;" scope="col">Valor Abonado</th>
          <th scope="col" v-if="current.estado == 'A'"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="det in current.aplicacionabonocargo_set" v-bind:key="det.id">
          <td scope="col">
            <router-link
              :to="{ name: 'cxp-abono-editar', params: { id: det.abono_e.id } }"
            >
              {{ det.abono_e.tipo_abono }}-{{ det.abono_e.documento }} // Saldo:
              {{ det.abono_e.total_pendiente }} Fecha: {{ det.fecha }}
            </router-link>
          </td>
          <td class="text-right" scope="col">Q {{ det.valor_total }}</td>
          <td class="text-center" scope="col" v-if="current.estado == 'A'">
            <button
              class="btn btn-danger btn-sm"
              @click="eliminarAbonoACargo(det)"
            >
              Eliminar
            </button>
          </td>
        </tr>
        <tr v-if="current.estado == 'A'">
          <td colspan="2">
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label>Tipo</label>
                  <select
                    class="form-control"
                    autofocus="autofocus"
                    v-model="apl_current.tipo_abono"
                    @change="refreshAbonos"
                  >
                    <option
                      v-for="(c, key) in tipos_abonos"
                      :value="c.id"
                      :key="key"
                      >{{ c.nombre }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        apl_current.errors.abono_e &&
                        apl_current.errors.abono_e.length > 0,
                    }"
                    >Abono</label
                  >
                  <select
                    class="form-control"
                    autofocus="autofocus"
                    v-model="apl_current.abono_e"
                  >
                    <option v-for="(c, key) in abonos" :value="c.id" :key="key">
                      Abono #{{ c.documento }} // Disponible: {{ c.total_pendiente }}
                    </option>
                  </select>
                  <small
                    v-if="apl_current.errors && apl_current.errors.abono_e"
                    class="form-text text-danger"
                    >{{ apl_current.errors.abono_e[0] }}</small
                  >
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        apl_current.errors.valor_total &&
                        apl_current.errors.valor_total.length > 0,
                    }"
                    >Abonar</label
                  >
                  <input
                    v-model="apl_current.valor_total"
                    class="form-control"
                    placeholder="Valor"
                    v-bind:class="{
                      'is-invalid':
                        apl_current.errors.valor_total &&
                        apl_current.errors.valor_total.length > 0,
                    }"
                    type="number"
                    step="0.05"
                  />
                  <small
                    v-if="apl_current.errors && apl_current.errors.valor_total"
                    class="form-text text-danger"
                    >{{ apl_current.errors.valor_total }}</small
                  >
                </div>
              </div>
            </div>
          </td>
          <td class="text-center">
            <button
              type="button"
              class="btn btn-sm btn-success"
              @click="agregarAbono"
            >
              Agregar
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="1">
            Total Abonado
          </td>
          <td class="text-right">Q {{ current.total_aplicado }}</td>
          <td class="text-right"></td>
        </tr>
      </tfoot>
    </table>

    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      data: [],
      abonos: [],
      apl_current: {
        tipo_abono: null,
        abono_e: null,
        valor_total: null,
        errors: {
          tipo_abono: null,
          abono_e: null,
          valor_total: null,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      tipos_abonos: "cxpabonos/tipoabono",
    }),
  },
  props: ["current"],
  mounted() {
    let self = this;
    self.refreshTipoCargo();
  },
  methods: {
    refreshTipoCargo() {
      let self = this;
      self.$store.dispatch("cxpabonos/tipoabono", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshAbonos() {
      let self = this;
      let params = {
        con_saldo_pendiente: "True",
        tipo_abono: self.apl_current.tipo_abono,
        proveedor: self.current.proveedor.codigo
      };
      DynamicService.fetch("cxp", "abonos", params).then((res) => {
        self.abonos = res.data;
      });
    },
    agregarAbono() {
      let self = this;
      let params = self.apl_current;
      DynamicService.postAction(
        "cxp",
        "cargos",
        self.current.id,
        "aplicar_abono",
        params
      )
        .then((res) => {
          self.$emit("refresh");
          self.refreshAbonos();
          self.apl_current = {
            tipo_abono: null,
            abono_e: null,
            valor_total: null,
            errors: {
              tipo_abono: null,
              abono_e: null,
              valor_total: null,
            },
          };
        })
        .catch((error) => {
          console.log(error.response.data);
          self.apl_current.errors = error.response.data;
          self.$emit("refresh");
          self.refreshAbonos();
        });
    },
    eliminarAbonoACargo(detalle) {
      let self = this;
      if (!confirm("¿Desea eliminar el abono al documento seleccionado?")) {
        return;
      }

      DynamicService.postAction(
        "cxp",
        "cargos",
        self.current.id,
        "eliminar_abono_aplicado",
        {
          id: detalle.id,
        }
      )
        .then((res) => {
          self.$emit("refresh");
          self.refreshAbonos();
        })
        .catch((error) => {
          console.log(error.response.data);
          self.$emit("refresh");
          self.refreshAbonos();
        });
    },
  },
};
</script>
